import { render } from "./PayuLog.vue?vue&type=template&id=0381ace0&scoped=true"
import script from "./PayuLog.vue?vue&type=script&lang=js"
export * from "./PayuLog.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=0381ace0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0381ace0"]])

export default __exports__